module.exports = __webpack_public_path__ + "static/media/butterfly9.a8b8c2bf.png";